import { render } from "./difficulty.vue?vue&type=template&id=3ed8f207"
import script from "./difficulty.vue?vue&type=script&lang=js"
export * from "./difficulty.vue?vue&type=script&lang=js"

import "./difficulty.vue?vue&type=style&index=0&id=3ed8f207&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__